import React  from 'react';
import UserComponentProto from '../../components/user-proto';

export default function renderCreatedByInList(className, placeholder, props) {
    return <UserComponentProto className={className} renderMode="list" renderValue="icon-name" placeholder={placeholder} {...props} />;
}